const $form = document.querySelector('.wpcf7-form');
const $formBtn = document.querySelector('.wpcf7-submit');
const $formError = document.querySelector('.wpcf7-response-output');

document.addEventListener('DOMContentLoaded', function () {
  $form.addEventListener('submit', function () {
    console.log('submit event');
    $formBtn.disabled = true;
    $form.classList.add('form--loading');
  });
});

document.addEventListener('wpcf7submit', function (event) {
  console.log('wpcf7submit event');
  if (event.detail.status == 'validation_failed') {
    $formBtn.disabled = false;
    $form.classList.remove('form--loading');
    $formError.classList.add('u--display-block');
  }
});

document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const contestID = urlParams.get('contest_id');

    location = '/contests/thank-you?contest_id=' + contestID;
  },
  false
);
